// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  type Node,
} from 'react';

import { Animation, Colors, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  /**
   * The error message to render.
   */
  children: Node,
};

const Styles = labelStyles(__filename, {
  toggle: {
    ...Typography.altText900,
    color: Colors.red600,
    cursor: 'pointer',
    padding: '3px 0',
    borderBottom: `1px solid transparent`,
    transition: Animation.transitionValue,
    '&:hover, &:focus': {
      borderBottomColor: Colors.red600,
    },
  },
  message: {
    color: Colors.red600,
    marginTop: 10,
    padding: 10,
    border: `1px solid ${Colors.grey200}`,
    borderRadius: 5,
    font: '14px/18px monospace',
  },
});

/**
 * Simple error message to render if, for instance, data
 * fails to load. Should ideally never be seen by users.
 */
const UniversalSidebarError = (props: Props) => {
  return (
    <details>
      <summary css={Styles.toggle}>Oh no, something went wrong!</summary>
      <pre css={Styles.message}>{props.children}</pre>
    </details>
  );
};

export default UniversalSidebarError;
